// istanbul ignore file

type PropertyManager = {
    id: string;
    name: string;
    position: string;
    email: string;
};

enum NotificationPreferenceType {
    NotAllowed = 'NOT_ALLOWED',
    OnlyCompliantServiceReports = 'ONLY_COMPLIANT_SERVICE_REPORTS',
    AllServiceReports = 'ALL_SERVICE_REPORTS'
}

type NotificationPreference = {
    id: NotificationPreferenceType;
    name: string;
    description: string;
    isAllowCompliantServiceReports: boolean;
    isAllowNonCompliantServiceReports: boolean;
};

type PropertyManagerNotificationPreferences = {
    isServiceReportsAutoOwnerEmailAllowed: boolean;
    preferences: {
        propertyManagerId: string;
        serviceReportsAutoOwnerEmailPreference: NotificationPreferenceType | null;
    }[];
    serviceAutoOwnerEmailOptions: NotificationPreference[];
};

type NotificationPreferenceUpdate = {
    propertyManagerId: number;
    serviceReportsAutoOwnerEmailPreference: NotificationPreferenceType;
};

export {
    PropertyManager,
    NotificationPreferenceType,
    PropertyManagerNotificationPreferences,
    NotificationPreferenceUpdate,
};
